enum DateOption {
    LastYear = 'last_year',
    YearToDate = 'year_to_date',
    AllTime = 'all_time',
}

export { DateOption };
